import React from 'react';

export const MenuItem: React.FC<{
    children: any;
    active?: boolean;
    width?: string;
    height?: string;
    hint?: string;
    url?: string;
}> = ({ children, active = false, width = 'auto', height = 'auto', hint, url }) => {
    const setStyle = {
        width: `${width}`,
        height: `${height}`,
        cursor: `${url ? 'pointer' : 'arrow'}`,
    };

    const handleClick: React.MouseEventHandler = (e) => {
        if (url) {
            window.location.href = url;
        }
    };

    return (
        <>
            <div
                className={`menuItem ${active ? 'active' : 'inactive'}`}
                style={setStyle}
                onClick={handleClick}
                title={hint}
            >
                {children}
            </div>
        </>
    );
};
